<template>
    <div class="lifeline-container text-center">
        <h5>Lifeline - {{ statusLabel }}</h5>
        <div class="hitpoints d-flex flex-wrap justify-content-center">
            <div
                v-for="i in hp"
                :key="'hitpoint-' + i"
                class="hitpoint-circle"
                :class="{ filled: i <= hitpoints }"
                @click="setHitpoints(i)"
                :title="`Hitpoint ${i}`"
            ></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LifelineTracker",
    props: {
        initial: {
            type: Number,
            default: 0,
        },
        hp: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            hitpoints: this.initial, // value from 0 to 16
            lastClickedHitpoint: null,
        };
    },
    computed: {
        statusLabel() {
            const count = this.hitpoints;
            if (count === this.hp) return "Dead";
            if (count >= 12) return "Trauma";
            if (count >= 8) return "Limping";
            if (count >= 4) return "Weakened";
            return "Healthy";
        },
    },
    methods: {
        setHitpoints(count) {
            if (this.lastClickedHitpoint === count) {
                // If the same hitpoint is clicked twice, turn it off
                this.hitpoints = count - 1;
                this.lastClickedHitpoint = null;
            } else {
                this.hitpoints = count;
                this.lastClickedHitpoint = count;
            }
            this.$emit("update", this.hitpoints);
        },
    },
};
</script>

<style scoped>
.lifeline-container {
    padding: 10px 5px;
    border: solid 2px #555;
    border-radius: 8px;
}
.hitpoints {
    max-width: 100%;
}

.hitpoint-circle {
    width: 24px;
    height: 24px;
    border: 2px solid #555;
    border-radius: 50%;
    display: inline-block;
    margin: 5px;
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s;
}

.hitpoint-circle.filled {
    background: #ff4136;
    border-color: #ff4136;
}
</style>

